<template>
    <div>
        <lower-floor
            v-if="floors.lower"
            :stores="floors.lower.stores"
            :units="floors.lower.units"
            :mapOver="mapOver"
            :listOver="listOver"
            @mapOver="makeMapOver"
            @listOver="makeListOver"
        ></lower-floor>
    </div>
</template>
<script>
    import LowerFloor from './Floors/Lower';
    export default {
        components: {
            'lower-floor': LowerFloor,
        },
        data() {
            return {
                url: '/api/store/floors',
                floors: {
                    lower: null
                },
                mapOver: null,
                listOver: null,
            }
        },
        created() {
            axios.post(this.url)
                .then(this.success)
                .catch(this.failure);
        },
        methods: {
            success(response) {
                this.floors = response.data;
            },
            failure(error) {
                console.log(error);
            },
            makeMapOver(id) {
                this.mapOver = id;
            },
            makeListOver(id) {
                this.listOver = id;
            }
        }
    }
</script>